import React from 'react';
import { mkTrack } from '../../marketing/track';

// Native <details>/<summary>: keyboard support for free, no extra ARIA. All items start closed.
const MkFaq = ({ items, page }) => (
  <div className="mk-faq">
    {items.map((item) => (
      <details
        key={item.id}
        className="mk-faq__item"
        onToggle={(e) => {
          if (e.currentTarget.open) mkTrack('faq_open', `${page}:${item.id}`);
        }}
      >
        <summary className="mk-faq__q">{item.q}</summary>
        <div className="mk-body mk-faq__a">
          <p>
            {item.a}
            {item.link && (
              <>
                {' '}
                <a className="mk-textlink" href={item.link.href}>
                  {item.link.label}
                </a>
              </>
            )}
          </p>
        </div>
      </details>
    ))}
  </div>
);

export default MkFaq;
